import createRoutine from '@/utils/createRoutine'

export const fetchMyApplications = createRoutine('FETCH_MY_APPLICATIONS')
export const setDeals = createRoutine('SET_DEALS')
export const setLoading = createRoutine('SET_LOADING')
export const setError = createRoutine('SET_ERROR')
export const setFetchedAt = createRoutine('SET_FETCHED_AT')

export const applicationsGetters = {
  DEALS: 'DEALS',
  IS_LOADING: 'IS_LOADING',
  HAS_ERROR: 'HAS_ERROR',
  LAST_FETCHED_AT: 'LAST_FETCHED_AT',
  LIVE_DEALS: 'LIVE_DEALS',
  CLOSED_DEALS: 'CLOSED_DEALS',
  INFORMATION_REQUESTED_DEALS: 'INFORMATION_REQUESTED_DEALS',
  INFORMATION_REQUESTED_COUNT: 'INFORMATION_REQUESTED_COUNT',
  HAS_INFORMATION_REQUESTED: 'HAS_INFORMATION_REQUESTED',
  ACTIONABLE_INFORMATION_REQUESTED_COUNT: 'ACTIONABLE_INFORMATION_REQUESTED_COUNT',
  IS_STALE: 'IS_STALE'
}
